export type Translations<T> = Record<string, T> | null;

export const getTranslation = <T>(
  translations: Translations<T>,
  field: keyof T,
  preferredLocale: string,
  defaultLocale: string
) => {
  if (!translations) return null;
  const preferred = translations[preferredLocale]?.[field];
  if (preferred) return preferred;
  const fallback = translations[defaultLocale]?.[field];
  if (fallback) return fallback;
  return null;
};
